"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLUGIN_SETTING_OWNER = void 0;
exports.PLUGIN_SETTING_OWNER = {
    CAMPAIGN: 'CAMPAIGN',
    LANDING: 'LANDING'
};
//# sourceMappingURL=pluginSettingOwner.js.map